interface baseMap {
  displayName: string
  children: any
}

class appConfig {
  mapView: any = null
  sceneView: any = null
  activeView: any = null
  mapInitParam: any = null
  container = "viewDiv"
  baseMap: baseMap[] = [] // 二维地图列表
  base3dMap: baseMap[] = [] // 三维地图列表
  extent2D: any = null
  camera: any = null
  detailMapView: any = null
  detailSceneView: any = null
  activeId = ""

  setMapInitParam(param: any) {
    this.mapInitParam = param
  }

  setExtent(extent: any) {
    this.extent2D = extent
  }

  setCamera(camera: any) {
    this.camera = camera
  }

  setId(id: string) {
    this.activeId = id
  }

  setMapView(map: any) {
    this.mapView = map
    this.extent2D = {
      xmin: this.mapInitParam.extent2D.xMin,
      xmax: this.mapInitParam.extent2D.xMax,
      ymin: this.mapInitParam.extent2D.yMin,
      ymax: this.mapInitParam.extent2D.yMax,
      spatialReference: this.mapView.spatialReference
    }
  }
  setDetailMapView(map: any) {
    this.detailMapView = map
    this.extent2D = {
      xmin: this.mapInitParam.extent2D.xMin,
      xmax: this.mapInitParam.extent2D.xMax,
      ymin: this.mapInitParam.extent2D.yMin,
      ymax: this.mapInitParam.extent2D.yMax,
      spatialReference: this.detailMapView.spatialReference
    }
  }

  setBaseMap(map: any) {
    this.baseMap = map
  }

  setDetailSceneView(map: any) {
    this.detailSceneView = map
    // this.camera = {
    //   heading: this.mapInitParam.extent3D.heading,
    //   position: {
    //     x: this.mapInitParam.extent3D.x,
    //     y: this.mapInitParam.extent3D.y,
    //     z: this.mapInitParam.extent3D.z,
    //     spatialReference: this.sceneView.spatialReference
    //   },
    //   tilt: this.mapInitParam.extent3D.tilt
    // }
  }
  setSceneView(map: any) {
    this.sceneView = map
    // this.camera = {
    //   heading: this.mapInitParam.extent3D.heading,
    //   position: {
    //     x: this.mapInitParam.extent3D.x,
    //     y: this.mapInitParam.extent3D.y,
    //     z: this.mapInitParam.extent3D.z,
    //     spatialReference: this.sceneView.spatialReference
    //   },
    //   tilt: this.mapInitParam.extent3D.tilt
    // }
  }

  setBase3dMap(map: any) {
    this.base3dMap = map
  }

  // 改变视图
  changeView(activeView: any) {
    this.activeView = activeView
  }

  // 获取图层
  getLayer(id: string) {
    return this.activeView && this.activeView.map.findLayerById(id)
  }

  // 重置-回到初始位置
  reset() {
    this.activeView.extent = this.extent2D
    // if (this.activeView.type === "2d") {
    //   this.activeView.extent = this.extent2D
    // } else {
    //   this.activeView.goTo(this.camera)
    // }
  }
}

export default new appConfig()
